import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import { FiGlobe, FiMail, FiMapPin } from "react-icons/fi";
import GoogleMapReact from "google-map-react";
import ContactTwo from "../elements/contact/ContactTwo";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import Breadcrumb from "../elements/common/Breadcrumb";
import { withTranslation } from "react-i18next";

class Contact extends Component {
  static defaultProps = {
    center: {
      lat: 59.95,
      lng: 30.33,
    },
    zoom: 11,
  };

  render() {
    const { i18n } = this.props;
    // Check the current language
    const isEnglish = i18n.language === "en";

    return (
      <React.Fragment>
        <Header
          headertransparent="header--transparent"
          colorblack="color--black"
          logoname="logo.png"
        />

        <Breadcrumb title={"Contact"} />

        <div className="rn-contact-top-area ptb--120 bg_color--5">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title mb--30 text-center">
                  <span className="subtitle">Contact</span>
                  <h2 className="title">Contact</h2>
                  <p className="description">
                    {isEnglish
                      ? "Don't hesitate to contact us if you have any question"
                      : "N'hésitez pas à nous contacter si vous avez des questions"}
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-6 col-12  mb--20">
                <div className="rn-address">
                  <div className="icon">
                    <FiGlobe />
                  </div>
                  <div className="inner">
                    <h4 className="title">Um6p Website</h4>
                    <p>
                      <a href="https://www.um6p.ma" target="_blank">
                        www.um6p.ma
                      </a>
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-6 col-12  mb--20">
                <div className="rn-address">
                  <div className="icon">
                    <FiMail />
                  </div>
                  <div className="inner">
                    <h4 className="title">
                      {isEnglish ? "Our Email Address" : "Notre adresse e-mail"}
                    </h4>
                    <p>
                      <a href="mailto:contact.cus@um6p.ma">
                        contact.cus@um6p.ma
                      </a>
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="rn-address">
                  <div className="icon">
                    <FiMapPin />
                  </div>
                  <div className="inner">
                    <h4 className="title">
                      {isEnglish ? "Our main office" : "Notre bureau principal"}
                    </h4>
                    <p>Lot 660, Hay Moulay Rachid, Ben Guerir 43150, Morocco</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="rn-contact-page ptb--120 bg_color--1">
          <ContactTwo />
        </div>

        <div className="backto-top">
          <ScrollToTop showUnder={160}>
            <FiChevronUp />
          </ScrollToTop>
        </div>

        <Footer />
      </React.Fragment>
    );
  }
}
export default withTranslation()(Contact);
